import { h as __h } from "preact";
import { relayKeyResponse } from "~/backend/validate.js";
/** @import { relayResponse } from "~/backend/validate.js"; */
import { ApiError, authedApiRequest, response } from "~/lib/api.js";
import { alert } from "~/util/alert.js";
import html from "~/util/html.js";
import Query from "~/util/query.js";
import { confirmModal } from "~/component/ConfirmModal.js";

/**
 * @param {{ orgId: string }} props
 * @param {relayResponse} relay
 */
export const regenerateKey = async ({
  orgId
}, relay) => {
  const res = await confirmModal({
    title: `Regenerate key for '${relay.name}'?`,
    action: "Regenerate",
    body: __h("p", {}, "The old key will stop working.")
  });
  if (!res) return;
  try {
    const result = await authedApiRequest("POST", `/v2/orgs/${orgId}/relays/${relay.id}/regenerate-key`, {
      schema: response(relayKeyResponse)
    });
    Query.invalidate([`/v2/orgs/${orgId}/relays`], [`/v2/orgs/${orgId}/relays/${relay.id}`]);
    return {
      name: relay.name,
      secret: result.data.key
    };
  } catch (err) {
    alert(ApiError.from(err).message, {
      type: "error"
    });
    return;
  }
};